import qoalaStorage from '~/core/Storage';
import { parseIfJsonString } from '~/core/helper/JSONHelper';

export default {
  getPolicy: state => {
    const policy = qoalaStorage.getItem('policy') ? parseIfJsonString(qoalaStorage.getItem('policy')) : state.policy;
    if (!policy) {
      return '';
    }
    if (policy === 'undefined') {
      return '';
    }
    if (typeof policy === 'string') {
      return JSON.parse(policy);
    }
    return policy;
  },
  getBenefits: state => {
    const benefit = qoalaStorage.getItem('benefits')
      ? parseIfJsonString(qoalaStorage.getItem('benefits'))
      : state.benefits;
    if (!benefit) {
      return '';
    }
    if (benefit === 'undefined') {
      return '';
    }
    if (typeof benefit === 'string') {
      return JSON.parse(benefit);
    }
    return benefit;
  }
};
